export default "__VITE_ASSET__DmMm6tDD__"